import styles from "./enter.module.css";
import LazyLoad from "react-lazyload";
const Enter = ({resources}) => {
  return (
    <section className={styles.ctn}>
        <h1>How To Enter</h1>
        <h4>
          Create a vertical B-Roll video that tells a story about your{" "}
          <span className={styles.colorfullText}>
            life / hobby / job or whatever you like
          </span>{" "}
          in 30 seconds...
        </h4>
      <LazyLoad className="m3-active-desktop">
          <img src={`${resources}m3challenge-howtoenter.png`} alt="" />
      </LazyLoad>

      <LazyLoad className="m3-active-mobile">
          <img src={`${resources}m3challenge-howtoenter-mobile.png`} alt="" />
      </LazyLoad>


    </section>
  );
};

export default Enter;
